import { createSelector } from 'reselect';

import * as types from '../actions/actionTypes';

/**
 * Reducer to keep the some currently selected things as default in state.
 *
 * @param state
 * @param action
 * @returns {*}
 */
export default (state, action) => {
    switch (action.type) {
        case types.SEWPAT_SELECTED:
            return Object.assign({}, state, {
                selectedSewpatId: action.sewpatId,
            });
        case types.FASHION_SIZE_SELECTED:
            return Object.assign({}, state, {
                selectedFashionSize: action.size,
            });
        case types.NAVIGATED_TO_HOME:
            return Object.assign({}, state, {
                hasSeenHome: state.hasSeenHome + 1,
            });
        default:
            return state;
    }
};

export const getUsersSewpatId = state => state.stolo.userdata.selectedSewpatId;
export const getUserSelectedFashionSize =
    state => state.stolo.userdata.selectedFashionSize;

export const isSubscribed = state => state.stolo.userdata.isSubscribed;
export const getHasSeenHome = state => state.stolo.userdata.hasSeenHome > 2;



// WEBPACK FOOTER //
// ./src/reducers/userdata.js